import moment from 'moment';
import React, {Fragment} from 'react';
import './SignatureElement.scss';

const SkipedAckElement = (props) => {
  return (
    <Fragment>
      <div className="signature-element skipped-acknowledged">
        <div className="signed">
          <div className="signed-text">Ack</div>
        </div>
        <div>
          <b>{props.acknowledgedBy}</b> {moment(props.acknowledgedAt).format('HH:mm on MMM D, YYYY')}
          {props.ackComment && (
            <div style={{paddingTop: '10px'}}>
              <div style={{fontSize: '0.9em', paddingTop: '10px'}}>{props.ackComment}</div>
            </div>
          )}
        </div>
      </div>

    </Fragment>
  );
};

export default SkipedAckElement;
